import { useMutation } from '@tanstack/react-query';
import { getGraphQLClient } from '@/common/graphqlClient';
import { graphql } from '@/generated/graphql';

const UPDATE_DELIVERY_AREAS_FROM_GEO = graphql(`
  mutation UpdateDeliveryAreasFromGeo($countryCode: String!) {
    updateDeliveryAreasFromGeo(countryCode: $countryCode) {
      applied
    }
  }
`);

export const useUpdateDeliveryAreasFromGeo = () => {
  const client = getGraphQLClient();

  return useMutation({
    mutationFn: (countryCode: string) =>
      client.request(UPDATE_DELIVERY_AREAS_FROM_GEO, { countryCode }),
  });
};
